import React, {Component, Fragment} from 'react'
import {Button, Row, Col, Card, CardBody} from 'reactstrap'
import PropTypes from 'prop-types'
import autobind from 'auto-bind'

import AssetQueue from '../AssetQueue'
import PartAdd from '../PartAdd'

export default class ProductionScheduler extends Component {
    propComponents = [
        {
            prop: 'name',
            component: 'GenericWidgetName',
        },
    ]
    showBorder = false
    id = 'ProductionScheduler'
    requiredOutputs = ['Part']
    static propTypes = {
        name: PropTypes.string,
    }
    constructor(props) {
        super(props)
        autobind(this)

        this.state = {}
    }

    render() {
        return (
            <Fragment>
                <Row className="mb-4">
                    <Col>
                        <PartAdd />
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col>
                        <AssetQueue />
                    </Col>
                </Row>
            </Fragment>
        )
    }
}
